<template>
  <div class="creative-landingpage">
    <ColumnBlock :title="title" @show-config-modal="onShowConfigModal" @clear="onClear">
      <div slot="title" class="block-title">
        <h4>{{ props.title }}</h4>
        <span>{{ configForm.landingPages.length }}/50 </span>
      </div>
      <div class="landing-page-items">
        <div v-for="(item, index) in landingPages" :key="item.targetingId" class="landing-page-item">
          <el-tooltip class="item" effect="dark" placement="top">
            <template #content>
              <p style="width: 400px">{{ item.contents.join('、') }}</p>
            </template>
            <span class="page-name">{{ item.packName }}（{{ item.contents.length }}） </span>
          </el-tooltip>

          <em @click="onPageItemRemove(index)" class="close-icon el-icon-error"></em>
        </div>
      </div>
    </ColumnBlock>

    <LandingPagePackageModal
      v-model="showDescInfoModal"
      :game-id="gameId"
      :op-id="opId"
      :media-id="MEDIAS.TOUTIAO"
      @confirm="onSelectConfirm"
    />
  </div>
</template>

<script setup>
import { ref, toRefs, computed, inject } from 'vue'
import ColumnBlock from '../layout/block.vue'
import LandingPagePackageModal from './components/landing-pages/index.vue'
import { MEDIAS } from '@/common/js/constants.js'

const { opId, getGameId } = inject('localStates')
// eslint-disable-next-line
const props = defineProps({
  title: String
})
const { title } = toRefs(props)

const { configForm, updateConfigForm } = inject('configForm')
const landingPages = computed(() => configForm.value.landingPages)
const gameId = computed(() => getGameId())

const showDescInfoModal = ref(false)

function onSelectConfirm(e) {
  const existIds = landingPages.value.map((item) => item.id)
  const newRows = {}

  for (const item of e) {
    if (existIds.includes(item.id)) continue
    if (newRows[item.id]) continue
    newRows[item.id] = item
  }
  const newRowsArr = Object.values(newRows)
  updateConfigForm({
    ...configForm.value,
    landingPages: landingPages.value
      .concat(newRowsArr)
      .slice(0, 50)
      .map((item) => ({ ...item, content: JSON.parse(item.content) }))
  })
}
function onPageItemRemove(index) {
  updateConfigForm({
    ...configForm.value,
    landingPages: landingPages.value.filter((item, i) => i !== index)
  })
}
function onClear() {
  updateConfigForm({
    ...configForm.value,
    landingPages: []
  })
}
function onShowConfigModal() {
  showDescInfoModal.value = true
}
</script>

<style lang="scss" scoped>
.creative-landingpage {
  .landing-page-items {
    padding: 10px;
    height: 292px;
    overflow: auto;
  }

  .landing-page-item {
    display: flex;
    padding: 6px 10px;

    justify-content: space-between;
    align-items: center;
    background: #eee;
    margin-bottom: 10px;
    border-radius: 4px;
    span.page-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 260px;
    }
  }

  .close-icon {
    cursor: pointer;
    font-size: 13px;
  }
}
</style>
